"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var rql_1 = require("../../schemas/rql");
var lodash_1 = require("lodash");
var parse_graphql_errors_1 = require("@reverbdotcom/commons/dist/parse_graphql_errors");
var gqlQuery = graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query AddressBook {\n    countries {\n      countries {\n        name\n        countryCode\n        subregions {\n          name\n          code\n        }\n      }\n    }\n    me {\n      shippingAddresses {\n        uuid\n        name\n        streetAddress\n        extendedAddress\n        locality\n        region\n        postalCode\n        countryCode\n        phone\n        primary\n        legacyId\n      }\n    }\n  }\n"], ["\n  query AddressBook {\n    countries {\n      countries {\n        name\n        countryCode\n        subregions {\n          name\n          code\n        }\n      }\n    }\n    me {\n      shippingAddresses {\n        uuid\n        name\n        streetAddress\n        extendedAddress\n        locality\n        region\n        postalCode\n        countryCode\n        phone\n        primary\n        legacyId\n      }\n    }\n  }\n"])));
var addressBookQuery = react_apollo_1.graphql(gqlQuery, {
    options: {
        ssr: true,
    },
});
var upsertAddressMutation = react_apollo_1.graphql(graphql_tag_1.default(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      mutation UpdateMyAddress($input: Input_core_apimessages_UpdateAddressRequest) {\n        updateMyAddress(input: $input) {\n          address {\n            uuid\n            name\n            streetAddress\n            extendedAddress\n            locality\n            region\n            postalCode\n            countryCode\n            phone\n            primary\n            legacyId\n          }\n        }\n      }\n    "], ["\n      mutation UpdateMyAddress($input: Input_core_apimessages_UpdateAddressRequest) {\n        updateMyAddress(input: $input) {\n          address {\n            uuid\n            name\n            streetAddress\n            extendedAddress\n            locality\n            region\n            postalCode\n            countryCode\n            phone\n            primary\n            legacyId\n          }\n        }\n      }\n    "]))), {
    name: 'upsertAddressMutation',
});
var deleteAddressMutation = react_apollo_1.graphql(graphql_tag_1.default(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      mutation DeleteMyAddress($input: Input_core_apimessages_AddressDeleteRequest) {\n        deleteMyAddress(input: $input) {\n          uuid\n        }\n      }\n    "], ["\n      mutation DeleteMyAddress($input: Input_core_apimessages_AddressDeleteRequest) {\n        deleteMyAddress(input: $input) {\n          uuid\n        }\n      }\n    "]))), {
    name: 'deleteAddressMutation',
});
function hoc(ChildComponent) {
    var Container = /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.handleDelete = _this.handleDelete.bind(_this);
            _this.handleUpdate = _this.handleUpdate.bind(_this);
            _this.handleCreate = _this.handleCreate.bind(_this);
            _this.handleMakePrimary = _this.handleMakePrimary.bind(_this);
            _this.handleValidationErrors = _this.handleValidationErrors.bind(_this);
            return _this;
        }
        class_1.prototype.handleMakePrimary = function (address) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var updateData;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            updateData = {
                                isPrimary: true,
                                uuid: address.uuid,
                                addressType: rql_1.core_apimessages_MyAddressType.SHIPPING,
                            };
                            return [4 /*yield*/, this.props.upsertAddressMutation({
                                    variables: { input: updateData },
                                    update: function (cache, response) {
                                        _this.unsetOldPrimaryIfNewPrimary(cache, response.data.updateMyAddress.address);
                                    },
                                    optimisticResponse: {
                                        __typename: 'Mutation',
                                        updateMyAddress: {
                                            __typename: 'core_apimessages_UpdateAddressResponse',
                                            address: tslib_1.__assign(tslib_1.__assign({}, address), { primary: true }),
                                        },
                                    },
                                })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        class_1.prototype.handleDelete = function (uuid) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var deleteRequest, _a;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            deleteRequest = { uuid: uuid };
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.props.deleteAddressMutation({
                                    variables: { input: deleteRequest },
                                    update: function (cache) {
                                        var data = cache.readQuery({ query: gqlQuery });
                                        data.me.shippingAddresses = data.me.shippingAddresses.filter(function (a) { return a.uuid !== uuid; });
                                        cache.writeQuery({
                                            data: data,
                                            query: gqlQuery,
                                        });
                                    },
                                })];
                        case 2:
                            _b.sent();
                            return [2 /*return*/, true];
                        case 3:
                            _a = _b.sent();
                            return [2 /*return*/, false];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        class_1.prototype.handleCreate = function (formData) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var mutationData, response, result, error_1;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            mutationData = this.formDataToMutationRequest(formData);
                            response = { address: null, errors: null };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.props.upsertAddressMutation({
                                    variables: { input: mutationData },
                                    update: function (cache, response) {
                                        var responseAddress = response.data.updateMyAddress.address;
                                        _this.unsetOldPrimaryIfNewPrimary(cache, responseAddress);
                                        var data = cache.readQuery({ query: gqlQuery });
                                        data.me.shippingAddresses.unshift(responseAddress);
                                        cache.writeQuery({
                                            data: data,
                                            query: gqlQuery,
                                        });
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            response.address = result.data.updateMyAddress.address;
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _a.sent();
                            response.errors = this.handleValidationErrors(error_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, response];
                    }
                });
            });
        };
        class_1.prototype.handleUpdate = function (formData) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var mutationData, response, result, errors_1;
                var _this = this;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            mutationData = this.formDataToMutationRequest(formData);
                            response = { address: null, errors: null };
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.props.upsertAddressMutation({
                                    variables: { input: mutationData },
                                    update: function (cache, response) {
                                        var responseAddress = response.data.updateMyAddress.address;
                                        _this.unsetOldPrimaryIfNewPrimary(cache, responseAddress);
                                    },
                                })];
                        case 2:
                            result = _a.sent();
                            response.address = result.data.updateMyAddress.address;
                            return [3 /*break*/, 4];
                        case 3:
                            errors_1 = _a.sent();
                            response.errors = this.handleValidationErrors(errors_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/, response];
                    }
                });
            });
        };
        class_1.prototype.handleValidationErrors = function (e) {
            var errors = parse_graphql_errors_1.parseGraphqlErrors(e);
            return errors;
        };
        class_1.prototype.unsetOldPrimaryIfNewPrimary = function (cache, newAddress) {
            if (!newAddress.primary) {
                return;
            }
            var data = cache.readQuery({ query: gqlQuery });
            var oldPrimary = data.me.shippingAddresses.find(function (a) { return a.primary && a.uuid !== newAddress.uuid; });
            if (!oldPrimary) {
                return;
            }
            oldPrimary.primary = false;
            cache.writeQuery({
                data: data,
                query: gqlQuery,
            });
        };
        class_1.prototype.formDataToMutationRequest = function (formData) {
            return {
                uuid: formData.uuid,
                addressType: rql_1.core_apimessages_MyAddressType.SHIPPING,
                address: {
                    name: formData.name,
                    streetAddress: formData.streetAddress,
                    extendedAddress: formData.extendedAddress,
                    postalCode: formData.postalCode,
                    phone: formData.phone,
                    region: formData.region,
                    locality: formData.locality,
                    countryCode: formData.countryCode,
                },
                isPrimary: formData.primary,
            };
        };
        class_1.prototype.render = function () {
            var _a = this.props, data = _a.data, passThroughProps = tslib_1.__rest(_a, ["data"]);
            var addresses = lodash_1.get(data, 'me.shippingAddresses') || [];
            return (React.createElement(ChildComponent, tslib_1.__assign({}, passThroughProps, { loading: data.loading, error: !!data.error, addresses: addresses, countries: lodash_1.get(data, 'countries.countries'), onCreate: this.handleCreate, onDelete: this.handleDelete, onMakePrimary: this.handleMakePrimary, onUpdate: this.handleUpdate })));
        };
        return class_1;
    }(React.Component));
    return react_apollo_1.compose(addressBookQuery, upsertAddressMutation, deleteAddressMutation)(Container);
}
exports.default = hoc;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=with_address_book_apollo.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/with_address_book_apollo.js
// module id = jb6V
// module chunks = 20 21